import { RotateCcw, Euro, LayoutDashboard, Clock, CheckSquare, Users, Building2, MapPin, CalendarDays, HeartPulse, ShieldCheck, Package, TrendingUp, PieChart, FileText, ScrollText, Settings, LifeBuoy, UserCog, SlidersHorizontal, Activity, Lock, Handshake, ConciergeBell, UsersRound, CalendarClock, GraduationCap, Briefcase, Wrench, BookOpen, ClipboardList, HardHat } from "lucide-react";

export const adminNav = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/approvals", label: "Approvals", icon: CheckSquare },
  { to: "/admin/timesheets", label: "Timesheets", icon: Clock },
  { to: "/admin/repair-log", label: "Repair Log", icon: Wrench },
  { to: "/admin/employees", label: "Employees", icon: Users },
  { to: "/admin/subcontractors", label: "Subcontractors", icon: HardHat },
  { to: "/admin/job-roles", label: "Job Roles", icon: Briefcase },
  { to: "/admin/compliance", label: "Compliance", icon: ShieldCheck },
  { to: "/admin/apprentices", label: "Apprentices", icon: GraduationCap },
  { to: "/admin/resources", label: "Resources", icon: BookOpen },
  { to: "/admin/forms", label: "Forms & Checklists", icon: ClipboardList },
  { to: "/admin/customers", label: "Customers", icon: Building2 },
  { to: "/admin/sites", label: "Sites", icon: MapPin },
  { to: "/admin/holidays", label: "Holiday Requests", icon: CalendarDays },
  { to: "/admin/sick-leave", label: "Sick Leave", icon: HeartPulse },
  { to: "/admin/leave-calendar", label: "Leave Calendar", icon: CalendarDays },
  { to: "/admin/materials", label: "Materials and Costs", icon: Package },
  { to: "/admin/site-profitability", label: "Site Profitability", icon: TrendingUp },
  { to: "/admin/customer-profitability", label: "Customer Profitability", icon: PieChart },
  { to: "/admin/site-report", label: "Site Report", icon: FileText },
  { to: "/admin/payroll", label: "Payroll Periods", icon: Lock },
  { to: "/admin/reports", label: "Reports", icon: FileText },
  { to: "/admin/request-services", label: "Request Services", icon: Handshake },
  { to: "/admin/audit", label: "Audit Log", icon: ScrollText },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

const ALWAYS_ON = ["/admin", "/admin/settings"];
export const MODULE_ITEMS = adminNav.filter((i) => !ALWAYS_ON.includes(i.to)).map((i) => ({ to: i.to, label: i.label }));

export const HUBS = [
  { label: "Finance", icon: Euro, home: "/admin/finance", paths: ["/admin/site-profitability", "/admin/customer-profitability", "/admin/materials"] },
  { label: "Leave", icon: CalendarDays, paths: ["/admin/holidays", "/admin/sick-leave", "/admin/leave-calendar"] },
];

export const MANAGER_PATHS = ["/admin/employees", "/admin/subcontractors", "/admin/compliance", "/admin/resources", "/admin/forms", "/admin/sites", "/admin/leave-calendar"];
export const managerNav = [
  { to: "/manager", end: true, label: "Home", icon: LayoutDashboard },
  ...adminNav.filter((i) => MANAGER_PATHS.includes(i.to)),
];

export const amdenNav = [
  { to: "/amden", end: true, label: "Dashboard", icon: LifeBuoy },
  { to: "/amden/companies", label: "Companies", icon: Building2 },
  { to: "/amden/service-requests", label: "Service Requests", icon: ConciergeBell },
  { to: "/amden/amden-users", label: "Amden Users", icon: UsersRound },
  { to: "/amden/access", label: "Support Access", icon: ShieldCheck },
  { to: "/amden/logs", label: "System Logs", icon: Activity },
  { to: "/amden/date-fix", label: "Timesheet Date Fix", icon: CalendarClock },
  { to: "/amden/ot-review", label: "Past Weeks Review", icon: CalendarClock },
  { to: "/amden/ot-policies", label: "Overtime Policies", icon: CalendarClock },
  { to: "/amden/audit", label: "Activity Review", icon: ScrollText },
  { to: "/amden/bin", label: "Deleted Items", icon: RotateCcw },
];
